/* eslint-disable no-useless-catch */
import React, { useEffect, useState, useContext } from "react";
import axios from "axios";
import { Form } from "react-bootstrap";
// import "bootstrap/dist/css/bootstrap.min.css";
import { EmailListSubscriptionRequestModal } from "EmailListSubscriptionRequestModal";
import { CompanyConnectionRequestModal } from "CompanyConnectionRequestModal";
import { UserContext } from "UserContext";
import teamMemberController from "controllers/teamMemberController.jsx";

const SecondaryCompanyCard = (props) => {
  const [hasPresented, setHasPresented] = useState(
    !!props.company.has_presented
  );
  const [userContext, dispatchUserContext] = useContext(UserContext);
  const [show, setShow] = useState(false);
  const [team, setTeam] = useState([]);
  let [userIsConnected, setUserIsConnected] = useState(false);
  let [userHasRequested, setUserHasRequested] = useState(false);

  const [shortenedWebsite, setShortenedWebsite] = useState("");

  useEffect(() => {
    const getUserInfo = async () => {
      if (props.company.name && userContext.user) {
        let result;
        try {
          result = await axios.get(
            "/api/v2/companies/" +
              props.company.project_id +
              "/users/" +
              userContext.user.user_id +
              "/connection_requests"
          );
        } catch (err) {
          console.log(err);
        }

        let connectionRequests = result.data;

        if (connectionRequests.length) {
          if (connectionRequests[0].active) {
            setUserIsConnected(true);
          } else {
            setUserHasRequested(true);
          }
        }
      }
    };
    const getTeamInfo = async () => {
      let team = await teamMemberController.getTeamMembersForCompany(
        props.company.project_id
      );
      setTeam(team);
    };
    getUserInfo();
    getTeamInfo();
  }, [userContext.user, props.company]);

  const handleClose = () => {
    setShow(false);
  };
  const handleShow = () => {
    setShow(true);
  };
  const handleSwitch = async () => {
    setHasPresented(!hasPresented);
    let company = props.company;
    props.company.has_presented = !props.company.has_presented;
    await axios.patch(
      "/api/v2/companies/" +
        props.companyId +
        "/virtual_events/" +
        company.virtual_event_id +
        "/participant_companies/" +
        company.project_id,
      {
        has_presented: !hasPresented,
      }
    );
    let newCompanies = props.companies.map((inner_company) => {
      if (inner_company.project_id === props.company.project_id) {
        return props.company;
      } else {
        return inner_company;
      }
    });
    props.socket.emit("virtual_event:list:update", newCompanies);
  };

  useEffect(() => {
    setHasPresented(!!props.company.has_presented);
  }, [props.company.has_presented]);

  // const marketTagsForCompany = props.company.tags ? props.company.tags.filter(tag =>
  //       tag.tag_tpe === "market_tag") : []
  //   }

  const marketTagsForCompany = () => {

    const tagsToShow = props.company.tags.filter(
      (tag) => tag.tag_type === "market_tag"
    );

    return tagsToShow

  };

  const marketTagsForCompanyHtml = marketTagsForCompany().map((tag, i) => {
    return (
      <span className={"ps-virtual-event-company-card__tag"} key={i}>
        {tag.display_name}
      </span>
    );
  });

  const NoActionButton = (props) => {
    return (
      <button
        className="btn ps-btn--primary ps-btn--primary--full"
        style={{
          maxWidth: "unset",
          cursor: "default",
          pointerEvents: "none",
          backgroundColor: "#CCE8FF",
          color: "#0695FC!important",
        }}
        id={`track-target-${props.company.project_id}`}
      >
        {props.label}
      </button>
    );
  };

  const RequestButton = (props) => {
    return (
      <button
        className="btn ps-btn--primary ps-btn--primary--full"
        id={`track-target-${props.company.project_id}`}
        style={{
          maxWidth: "unset",
        }}
        onClick={() => {
          setShow(true);

          try {
            let eventProperties = {
              companyName: props.company.name,
              companyID: props.company.project_id,
            };
            PSBase.analytics.logAmplitudeEvent(
              "company engagement: clicked connect/subscribe",
              eventProperties
            );
          } catch (err) {
            console.error(err);
          }
        }}
      >
        {props.label}
      </button>
    );
  };
  return (
    <div
      key={props.company.project_id + "card"}
      className={
        props.isMobile
          ? "ps-virtual-event-company-card__mobile"
          : "ps-virtual-event-company-card"
      }
    >
      <div className="ps-virtual-event-company-card__left-section">
        {!props.isMobile && (
          <div className="ps-virtual-event-company-card__left-section--logo-handle">
            <div className={"ps-virtual-event-company-card__logo-bounding-box"}>
              <a
                href={"/" + props.company.name}
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  className={"ps-virtual-event-company-card__logo"}
                  src={props.company.logo_url}
                  alt=""
                />
                {props.userHasAdminOverVirtualEvent && (
                  <img
                    {...props.provided.dragHandleProps}
                    src="/images/icons/drag-indicator-gray-icon.svg"
                    className={"ps-virtual-event-company-drag-icon"}
                    alt=""
                  />
                )}
              </a>
            </div>
          </div>
        )}
        <div
          className={
            props.isMobile
              ? "ps-virtual-event-company-card__left-section--content ml-0"
              : "ps-virtual-event-company-card__left-section--content"
          }
          style={{ width: props.isMobile ? "100%" : "80%" }}
        >
          <div>
            <div className={"ps-virtual-event-company-card__header-box"}>
              {props.isMobile && (
                <div
                  className={
                    "ps-virtual-event-company-card__logo-bounding-box mr-3"
                  }
                >
                  <img
                    className={"ps-virtual-event-company-card__logo"}
                    src={props.company.logo_url}
                    alt=""
                  />
                </div>
              )}
              <div className={"ps-virtual-event-company-card__title-team-box"}>
                <div className={"ps-virtual-event-company-card__title-status"}>
                  <a
                    href={"/" + props.company.name}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <span
                      className={"ps-virtual-event-company-card__title mr-3"}
                    >
                      {props.company.display_name}
                    </span>
                  </a>
                  {props.currentlyPresenting && props.showPresentingLabels && (
                    <div
                      className={"d-flex flex-direction-row align-items-center"}
                    >
                      <div
                        className={
                          "ps-virtual-event-company-card__presenting-icon mr-2"
                        }
                      ></div>
                      <div
                        className={"ps-virtual-event-company-card__presenting"}
                      >
                        Presenting
                      </div>
                    </div>
                  )}
                  {props.upNext && props.showPresentingLabels && (
                    <div className={"ps-virtual-event-company-card__next-up"}>
                      Next Up
                    </div>
                  )}
                  {!props.currentlyPresenting &&
                    !props.upNext &&
                    props.company.has_presented &&
                    props.showPresentingLabels && (
                      <div
                        className={"ps-virtual-event-company-card__presented"}
                      >
                        Presented
                      </div>
                    )}
                </div>
                <div
                  className={
                    props.isMobile
                      ? "ps-virtual-event-company-card__team w-100"
                      : "ps-virtual-event-company-card__team"
                  }
                >
                  {team.length > 0 && (
                    <div
                      className={"ps-virtual-event-company-card__teammembers"}
                    >
                      {team
                        .map(
                          (member) => `${member.first_name} ${member.last_name}`
                        )
                        .join(", ")}
                    </div>
                  )}
                </div>
              </div>
            </div>
            <div className="ps-virtual-event-company-card__description-more-details-container">
              <p
                className={
                  props.isMobile
                    ? "ps-virtual-event-company-card__description w-100"
                    : "ps-virtual-event-company-card__description"
                }
              >
                {props.company.short_description}
              </p>
            </div>
          </div>
          <div className={"ps-virtual-event-company-card__tag-container"}>
            {marketTagsForCompanyHtml}
            {/* {marketTagsForCompany &&
              props.company.tags.map((tag, i) => {
                return (
                  <span
                    className={"ps-virtual-event-company-card__tag"}
                    key={i}
                  >
                    {tag.display_name}
                  </span>
                );
              })} */}
          </div>
        </div>
      </div>
      <div
        className={
          props.isMobile
            ? "ps-virtual-event-company-card__right-sectio w-100"
            : "ps-virtual-event-company-card__right-section"
        }
      >
        <div
          className={
            props.isMobile
              ? ""
              : "ps-virtual-event-company-card__more-details-container"
          }
        >
          {!props.isMobile && (
            <div className={"ps-virtual-event-company-card__button-box"}>
              {userContext.user &&
                userContext.user.user_id &&
                userIsConnected && (
                  <NoActionButton label={"Connected"} {...props} />
                )}

              {userContext.user &&
                userContext.user.user_id &&
                userHasRequested &&
                !userIsConnected && (
                  <NoActionButton label={"Pending"} {...props} />
                )}

              {userContext.user &&
                userContext.user.user_id &&
                !userIsConnected &&
                !userHasRequested && (
                  <RequestButton label={"Connect"} {...props} />
                )}

              {!userContext.user && !userHasRequested && (
                <RequestButton label={"Subscribe"} {...props} />
              )}
              {!userContext.user && userHasRequested && (
                <NoActionButton label={"Pending"} {...props} />
              )}
            </div>
          )}
          <div className="ps-virtual-event-company-card__more-links-container">
            <a
              href={"/" + props.company.name}
              target="_blank"
              rel="noopener noreferrer"
            >
              <div className="ps-virtual-event-company-card__more-links-item">
                <img src="/images/icons/home-black-icon.svg" alt="home icon" />
                <span style={{ fontSize: "16px", paddingLeft: "10px" }}>
                  View profile
                </span>
              </div>
            </a>

            {/* {shortenedWebsite() && (
              <div className="ps-virtual-event-company-card__more-links-item">
                <img
                  src="/images/icons/globe-black-icon.svg"
                  alt="globe icon"
                />
                <span style={{ fontSize: "16px", paddingLeft: "10px" }}>
                  {shortenedWebsite()}
                </span>
              </div>
            )} */}
            {props.company.calendar_url && (
                <a
                  href={props.company.calendar_url}
                  target="_blank"
                  rel="noopener noreferrer"
                  onClick={() => {
                    try {
                      let eventProperties = {
                        companyName: props.company.name,
                        companyID: props.company.project_id,
                      };
                      PSBase.analytics.logAmplitudeEvent(
                        "company engagement: clicked schedule a meeting",
                        eventProperties
                      );
                    } catch (err) {
                      console.error(err);
                    }
                  }}
                >
                  <div className="ps-virtual-event-company-card__more-links-item">
                    <img
                      src="/images/icons/clock-black-icon.svg"
                      alt="clock icon"
                    />
                    <span style={{ fontSize: "16px", paddingLeft: "10px" }}>
                      Schedule a meeting
                    </span>
                  </div>
                </a>
              )}
            {props.isMobile && (
              <div className={"ps-virtual-event-company-card__button-box mt-2"}>
                {userContext.user &&
                  userContext.user.user_id &&
                  userIsConnected && (
                    <NoActionButton label={"Connected"} {...props} />
                  )}

                {userContext.user &&
                  userContext.user.user_id &&
                  userHasRequested &&
                  !userIsConnected && (
                    <NoActionButton label={"Pending"} {...props} />
                  )}

                {userContext.user &&
                  userContext.user.user_id &&
                  !userIsConnected &&
                  !userHasRequested && (
                    <RequestButton label={"Connect"} {...props} />
                  )}

                {!userContext.user && !userHasRequested && (
                  <RequestButton label={"Subscribe"} {...props} />
                )}
                {!userContext.user && userHasRequested && (
                  <NoActionButton label={"Pending"} {...props} />
                )}
              </div>
            )}
          </div>
        </div>

        {props.userHasAdminOverVirtualEvent && (
          <div
            className={
              "d-flex flex-direction-row justify-content-end align-items-center"
            }
          >
            <span>has presented: </span>
            <input
              type="radio"
              id={props.company.name}
              label="Presented"
              checked={hasPresented}
              onClick={handleSwitch}
              onChange={() => {}}
              className={"ps-checkbox ps-checkbox--primary ml-2"}
            />
          </div>
        )}

        {userContext.user && userContext.user.user_id && (
          <CompanyConnectionRequestModal
            userId={userContext.user.user_id}
            show={show}
            handleClose={(success) => {
              if (success) {
                setUserHasRequested(true);
              }
              handleClose();
            }}
            company={props.company}
          />
        )}
        {!userContext.user && (
          <EmailListSubscriptionRequestModal
            show={show}
            handleClose={(success) => {
              if (success) {
                setUserHasRequested(true);
              }
              handleClose();
            }}
            company={props.company}
          />
        )}
      </div>
    </div>
  );
};

export { SecondaryCompanyCard };
